import React from 'react';
import PersonIcon from '@material-ui/icons/Person';
import config from './config';
import Collaborator from './pages/Collaborator';
import Layout from '../../components/Layout';

const path = config.PATH;
const name = config.NAME;

const routes = [
  {
    name,
    path,
    component: Layout,
    icon: <PersonIcon />,
    routes: [
      { name: 'Afiliados', path: `${path}/colaborador`, component: Collaborator },
    ],
  },
];

export default routes;
